module.exports = __webpack_public_path__ + "static/media/3.c27aad31.webm";